
$(document).ready(function(){
  $('ul.shopify-tabs > li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $(this).parent().find('li').removeClass('current');
    $('.shopify-tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
  
//   $(".blog-listing.mobile").mCustomScrollbar({
//     axis:"x",
//     advanced:{
//       autoExpandHorizontalScroll:true
//     }
//   });
  
  $('.blog-listing li.tab_class').removeAttr('title');
  
//   $('.template-blog ul.blog__posts').slick('reinit').slick('unslick');
  
});

// Related slider

if( window.innerWidth < 769 ) {
  $(function(){
      $('.related-articles').slick({
			slidesToShow: 1,
            arrows: false,
            dots: true
      });
  });
}
